import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import utils from "@utils";

const TimeInput = props => {
	const { name, id, time, handleChange, className, disabled, min, max, user } = props;

	const militaryTimeMask = value => {
		const chars = value.split("");
		const hours = [/[0-2]/, chars[0] === "2" ? /[0-3]/ : /[0-9]/];
		const minutes = [/[0-5]/, /[0-9]/];
		return hours.concat(":").concat(minutes);
	};

	const shouldUseMaskedInput = utils.isDesktopSafari || utils.isIE || user?.UserPreferences;

	return (
		<>
			<If condition={shouldUseMaskedInput}>
				<MaskedInput
					name={name}
					id={id}
					type="text"
					mask={militaryTimeMask}
					disabled={disabled}
					min={min}
					max={max}
					className={className}
					placeholder="hh:mm"
					value={time}
					onChange={handleChange}
				/>
			</If>
			<If condition={!shouldUseMaskedInput}>
				<input
					name={name}
					id={id}
					className={className}
					type="time"
					min={min}
					max={max}
					disabled={disabled}
					value={time}
					onChange={handleChange}
				/>
			</If>
		</>
	);
};

TimeInput.propTypes = {
	name: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	user: PropTypes.any.isRequired,
	time: PropTypes.any,
	handleChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	min: PropTypes.any,
	max: PropTypes.any,
	className: PropTypes.any,
};

TimeInput.defaultProps = {
	time: null,
	className: "",
	disabled: false,
	min: undefined,
	max: undefined,
};

export default TimeInput;
